import React from 'react';

const WindmillIcon = (props) => {
  return (
    <img
      alt="Wiatrak"
      src="/static/images/icons/place_types/windmill.svg"
      {...props}
    />
  );
};

export default WindmillIcon;
